export interface AdjustmentCancel {
    item: string
    number: number
    charge: number
}
export interface ObjectToAdjustmentCancelProps {
    item: string
    number: number | string
    charge: number | string
}
export const ObjectToAdjustmentCancel = (obj: ObjectToAdjustmentCancelProps): AdjustmentCancel => {
    return {
        item: obj.item,
        number: typeof obj.number === "string" ? parseInt(obj.number) : obj.number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
    }
}